import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, tailFormItemLayout, unexpectedError } from '../../../common_functions';

const PaperFamily = props => {
  const { section, id } = useParams();
  const [family, setFamily] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        if (id !== 'new') {
          const { data } = await props.getItem('paper_family', id, { fields: ['id,name,note'] });
          setFamily(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    let newState = {
      ...family,
      ...values,
    };
    try {
      setLoading(true);
      let { data } = await props.saveItem('paper_family', newState);
      if (data) {
        notification['success']({
          message: 'Paper family saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/paper-family`);
      }
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/paper-family" }, { title: "Paper Family", href: "/settings/paper-family" }, { title: id !== 'new' ? `Edit Paper Family` : 'Add Paper Family' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Paper Family : ${id}` : 'Add Paper Family'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: 'Name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Paper Family Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="note" label="Note">
                    <Input.TextArea placeholder="Enter Note..." />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/paper-family')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_paper_family, family?.id ?? '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default PaperFamily;
